var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('strong',[_vm._v("Why can't I register?")])]},proxy:true}])},[_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.rules),function(rule){return _c('b-list-group-item',{key:rule},[_vm._v(_vm._s(rule))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }